import type {JSX, ReactElement, ReactNode} from 'react'
import React, {cloneElement, isValidElement} from 'react'
import {clsx} from 'clsx'
import {useWindowSize} from '@/_new-code/utilities/hooks/use-window-size'

interface HeaderBlockCarouselSlideProps {
	className?: string
	button: ReactNode
	image: ReactElement<{
		className: string
	}> | null
	subheading: string
	heading: string
	url: string
	headingUrl: string
	isContentOnTopOfImage?: boolean
}

export const HeaderBlockCarouselSlide = ({
	className = '',
	button,
	image,
	subheading,
	heading,
	url,
	headingUrl,
	isContentOnTopOfImage,
}: HeaderBlockCarouselSlideProps): JSX.Element => {
	const size = useWindowSize()
	const isMobile = size.isMobile

	// Render heading as h1 for all slides
	const HeadingTag = 'h1'
	const renderHeading = (headingClassName: string) => (
		<HeadingTag className={headingClassName}>{heading}</HeadingTag>
	)

	// Render image with consistent styling
	const renderImage = () =>
		isValidElement(image)
			? cloneElement(image, {
					className: 'w-full object-cover',
				})
			: null

	// Render image link wrapper
	const renderImageLink = () => <a href={url}>{renderImage()}</a>

	if (!isContentOnTopOfImage) {
		return (
			<div className={clsx('relative', className)}>
				{renderImageLink()}
				<div className="bottom-0 w-full pl-6 pr-6">
					<div className="slide-text-block mx-auto max-w-screen-xl items-center justify-between p-4 md:flex">
						<div className="md:mr-1">
							<a href={url}>
								<p>{subheading}</p>
							</a>
							<a href={headingUrl}>{renderHeading('mb-4')}</a>
						</div>
						{Boolean(button) && button}
					</div>
				</div>
			</div>
		)
	}
	if (!isMobile) {
		return (
			<div className={clsx('relative', className)}>
				{subheading && heading ? (
					<>
						<div className="absolute h-full w-full">
							<div className="container-wide flex h-full items-center">
								<div className="flex h-full w-full items-center">
									<div className="items-left max-w-2/3 w-1/2 flex-col justify-between rounded-lg bg-white p-2 md:flex lg:w-1/3 lg:p-4 2xl:h-[210px]">
										<div className="pb-4 md:mr-1">
											<a href={headingUrl}>
												{renderHeading(
													'mb-2 text-2xl leading-none text-black lg:mb-4'
												)}
											</a>
											<a href={url}>
												<p className="text-black">
													{subheading}
												</p>
											</a>
										</div>
										{Boolean(button) && button}
									</div>
								</div>
							</div>
						</div>
						{renderImageLink()}
					</>
				) : (
					renderImageLink()
				)}
			</div>
		)
	}

	return (
		<div className={clsx('relative', className)}>
			{subheading && heading ? (
				<>
					{renderImageLink()}
					<div className="bottom-0 w-full pl-6 pr-6">
						<div className="slide-text-block mx-auto max-w-screen-xl items-center justify-between p-4 md:flex">
							<div className="md:mr-1">
								<a href={url}>
									<p>{subheading}</p>
								</a>
								<a href={headingUrl}>{renderHeading('mb-4')}</a>
							</div>
							{Boolean(button) && button}
						</div>
					</div>
				</>
			) : (
				renderImageLink()
			)}
		</div>
	)
}
